import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

@withRouter
export default class SectionWithHeader extends React.Component {
  
  static propTypes = {
    title : PropTypes.string,
    headerChildren: PropTypes.any
  }

  static defaultProps = {
    title: '',
    headerChildren: null,
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={styles.SectionWithHeader}>
        <div className={styles.Header}>
          <h1>{this.props.title}</h1>
          <div className={styles.HeaderRight}>
            {this.props.headerChildren}
          </div>
        </div>
        {this.props.children}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/layout/SectionWithHeader/index.jsx